import { SMART_SENSOR_DCU, SMART_SENSOR } from '../constants';

export const DownloadLogsModalStatus = {
    FORM: 'FORM',
    CHECKING: 'CHECKING',
    READY: 'READY',
    EXCEEDED: 'EXCEEDED',
    PREPARING: 'PREPARING',
    TIMEOUT: 'TIMEOUT'
};

export const DownloadLogsReportingPeriod = {
    MAX_DAYS_RANGE: 90,
    MAX_DAYS_BACK: 90,
    PRESELECTED_DAYS: 1
};

export const DownloadLogsBannerVariant = {
    SUCCESS: 'success',
    WARNING: 'warning'
};

export const DownloadLogsLoaderSize = {
    CALCULATING: 'xsmall',
    PREPARING: 'medium'
};

export const DownloadLogsToastProgressDurationMs = 3000;

// Shown as the download size limit before the check-download-limit response provides the actual value.
export const DownloadLogsDefaultLimitInBytes = 50 * 1024 * 1024;
// Shown as the max file count before the check-download-limit response provides the actual value.
export const DownloadLogsDefaultMaxFileCount = 700;
export const DownloadLogsTextFields = [
    {
        key: 'fileName',
        payloadKey: 'fileNameStartsWith',
        id: 'download-logs-modal-file-name-input',
        labelKey: 'ABB.Powertrain.Frontend.fileName',
        placeholderKey: 'ABB.Powertrain.Frontend.searchEventBySerialNumberInputPlaceholder',
        appliesTo: [SMART_SENSOR_DCU]
    },
    {
        key: 'eventName',
        payloadKey: 'messageTextContains',
        id: 'download-logs-modal-event-name-input',
        labelKey: 'ABB.Powertrain.Frontend.downloadLogsEventNameLabel',
        placeholderKey: 'ABB.Powertrain.Frontend.searchEventBySerialNumberInputPlaceholder',
        appliesTo: [SMART_SENSOR]
    },
    {
        key: 'dcuSerialNumber',
        payloadKey: 'dcuSerialNumber',
        id: 'download-logs-modal-dcu-serial-input',
        labelKey: 'ABB.Powertrain.Frontend.searchEventBySerialNumberLabel',
        placeholderKey: 'ABB.Powertrain.Frontend.searchEventBySerialNumberInputPlaceholder',
        appliesTo: [SMART_SENSOR_DCU, SMART_SENSOR]
    }
];

